import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlBuilderService } from '@common/services/url-builder.service'
import { ProductListerConfigDto } from '@admin/containers/system-configuration-page/sections/lister-configuration/lister-configuration.types';

@Injectable()
export class ListerConfigurationHttpService {
    constructor(
        private readonly http: HttpClient,
        private readonly urlBuilder: UrlBuilderService
    ) { }

    getConfig(listerName: string, productName: string): Observable<ProductListerConfigDto> {
        const url = this.urlBuilder.getUrl(`admin/listerConfiguration`);
        return this.http.post<ProductListerConfigDto>(url, {Name: listerName, Product: productName});
    }

    saveListerConfiguration(request: ProductListerConfigDto[]): Observable<object>{
      const url = this.urlBuilder.getUrl('admin/listerConfiguration/save');

      return this.http.post<object>(url, {ProductListerConfigurations: request});
    }
}